import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import * as React from "react";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} size="small" />
))(({ theme }) => ({
  width: 34, // Reduced from 50
  height: 20, // Reduced from 26
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(12px)", // Adjusted for smaller size
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16, // Reduced from 22
    height: 16, // Reduced from 22
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2, // Adjusted to match height
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default function SwitchComp({ checked, handleChange, label, name }) {
  const switchStyle = label ? { m: 1 } : {};

  const control = (
    <IOSSwitch
      sx={switchStyle}
      checked={checked}
      onChange={(e) => handleChange(e.target.checked)}
    />
  );
  return (
    <FormGroup>
      {/* <FormControlLabel
        labelPlacement="start"
        name=""
        control={
          <IOSSwitch
            sx={{ m: 1 }}
            checked={checked}
            onChange={(e) => handleChange(e.target.checked)}
          />
        }
        label={label}
      /> */}
      {label ? (
        <FormControlLabel
          labelPlacement="start"
          name={name}
          control={control}
          label={label}
        />
      ) : (
        control
      )}
    </FormGroup>
  );
}
